var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlansIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.477,
    height: 21.476,
    viewBox: "0 0 21.477 21.476",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "magic-wand",
    d: "M16.167,8.137a2.737,2.737,0,0,0-.808-1.943,2.818,2.818,0,0,0-3.891,0L.816,16.849A2.751,2.751,0,0,0,4.7,20.737L15.359,10.082a2.735,2.735,0,0,0,.808-1.945ZM3.434,19.47a.976.976,0,0,1-1.347,0,.953.953,0,0,1,0-1.347l6.974-6.975L10.412,12.5ZM14.091,8.812l-2.413,2.414L10.332,9.875l2.414-2.413a.954.954,0,1,1,1.347,1.347ZM4.373,2.563l1.391-.4.4-1.391a1.069,1.069,0,0,1,2.056,0l.4,1.391,1.391.4a1.069,1.069,0,0,1,0,2.056l-1.391.4-.4,1.391a1.069,1.069,0,0,1-2.056,0l-.4-1.391-1.391-.4a1.069,1.069,0,0,1,0-2.056ZM20.778,15.391l-1.391.4-.4,1.391a1.069,1.069,0,0,1-2.056,0l-.4-1.391-1.391-.4a1.069,1.069,0,0,1,0-2.056l1.391-.4.4-1.391a1.069,1.069,0,0,1,2.056,0l.4,1.391,1.391.4a1.069,1.069,0,0,1,0,2.056ZM15.947,2.244,17.164,1.9,17.513.678a.935.935,0,0,1,1.8,0L19.656,1.9l1.217.347a.935.935,0,0,1,0,1.8l-1.217.347-.347,1.22a.935.935,0,0,1-1.8,0l-.347-1.216L15.947,4.04a.935.935,0,0,1,0-1.8Z",
    transform: "translate(-0.077 0)",
    fill: "#ff643a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansIcon4);
export default __webpack_public_path__ + "static/media/plans-icon4.36ac9f1ba3bf8b68adb04c0008172e98.svg";
export { ForwardRef as ReactComponent };